// import { MoreVert } from "@mui/icons-material";
import { Paper } from "@mui/material";
import React from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./DashBoardTile.module.scss";


export const DashboardTile = (props) => {
  return (
    <Paper className={styles.container}>
      <Row className={styles.firstRow}>
        <Col className={styles.left}>
          <div className={styles.title}>{props.title}</div>
          <div className={styles.subTitle}>{props.subTitle} </div>
        </Col>
        <Col className={styles.right}>
          {/* <MoreVert className={styles.optionsIcon} /> */}
          {/* <div>right</div> */}
        </Col>
      </Row>
      <div className={styles.bodyWrapper}>{props.children}</div>
    </Paper>
  );
};
